module.exports = __webpack_public_path__ + "static/media/card-duvidas.047e99f6.png";